var path = 'app/scripts/modules/ecs/serverGroup/configure/wizard/templateSelection/templateSelection.html';
var html = "<deploy-initializer cloud-provider=\"ecs\"\n                    command=\"command\"\n                    application=\"application\"\n                    parent-state=\"state\"\n                    template-selection-text=\"ctrl.templateSelectionText\"\n                    on-template-selected=\"ctrl.templateSelected()\"></deploy-initializer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/serverGroup/configure/wizard/templateSelection/templateSelection.html
// module id = 1620
// module chunks = 0